var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c(
        "div",
        [
          _c("div", { staticClass: "info--text text-uppercase my-3" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.generateMessage("requests.details.titles.general")) +
                "\n  "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex pl-3" },
            [
              _c("custom-simple-table", {
                staticStyle: { width: "40%" },
                attrs: {
                  item: _vm.property,
                  "i18-path": "properties_360.fields",
                  "table-keys": [
                    "code",
                    "name",
                    "contractual_commitment.services_type",
                    "usage.market_type"
                  ]
                }
              }),
              _vm._v(" "),
              _c("custom-simple-table", {
                staticClass: "px-2",
                staticStyle: { width: "40%" },
                attrs: {
                  item: _vm.property,
                  "i18-path": "properties_360.fields",
                  "table-keys": [
                    "address",
                    "entity",
                    "agency_name",
                    "entity_resp"
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "px-2", staticStyle: { width: "20%" } },
                [
                  _c("display-checkbox", {
                    staticClass: "d-block",
                    attrs: {
                      label: _vm.generateMessage(
                        "properties_360.fields.contractual_commitment.preventive_ordo"
                      ),
                      "input-value":
                        _vm.property.contractual_commitment?.preventive_ordo
                    }
                  }),
                  _vm._v(" "),
                  _c("display-checkbox", {
                    staticClass: "d-block",
                    attrs: {
                      label: _vm.generateMessage(
                        "properties_360.fields.contractual_commitment.request_ordo"
                      ),
                      "input-value":
                        _vm.property.contractual_commitment?.request_ordo
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("orders-accordion", { attrs: { beginOpen: "" } })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }